import { Diagram, DriveType, Locations, Position } from "@dana/Services/PartsLocations";
import InteractiveToolState from "@dana/Store/Data/InteractiveTool/InteractiveToolState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { AttributeValueFacetModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: InteractiveToolState = {
    isLoading:false,
    positionFlag: false,
    year: "",
    make: "",
    model: "",
    selectedYear: null,
    selectedMake: null,
    selectedModel: null,
    selectedDriveTypeId: "",
    selectedDriveTypeName: "",
    selectedDrigram: "",
    selectedPositions: [],
    locations: [],
    driveTypes: [],
};

const interactiveToolStateStateImmerReducer = createTypedReducerWithImmer(initialState, {
    "InteractiveTool/Init": (draft: Draft<InteractiveToolState>, action: { isOpen: boolean }) => {
        draft = { ...initialState, positionFlag: action.isOpen };
        return draft;
    },
     "InteractiveTool/IsLoading": (draft: Draft<InteractiveToolState>, action: { isLoading: boolean }) => {
        draft = { ...draft, isLoading: action.isLoading };
        return draft;
    },
    "InteractiveTool/SetMakeModelYear": (draft: Draft<InteractiveToolState>, action: { selectedYear: AttributeValueFacetModel, selectedMake: AttributeValueFacetModel, selectedModel: AttributeValueFacetModel }) => {
        draft = {
            ...draft,
            year: action.selectedYear.value,
            selectedYear: action.selectedYear,
            make: action.selectedMake.value,
            selectedMake: action.selectedMake,
            model: action.selectedModel.value,
            selectedModel: action.selectedModel
        };

        return draft;
    },
    "InteractiveTool/RemoveMakeModelYear": (draft: Draft<InteractiveToolState>) => {
        draft = {
            ...draft,
            year: "",
            make: "",
            model: "",
            locations: [],
            driveTypes: [],
        };
        return draft;
    },
    "InteractiveTool/LoadLocations": (draft: Draft<InteractiveToolState>, action: { locations: Locations[], driveTypes: DriveType[] }) => {
        draft = {
            ...draft,
            locations: action.locations,
            driveTypes: action.driveTypes,
        };
        return draft;
    },
    "InteractiveTool/SetDriveType": (draft: Draft<InteractiveToolState>, action: { driveType: DriveType }) => {
        draft = {
            ...draft,
            selectedDriveTypeId: action.driveType.id,
            selectedDriveTypeName: action.driveType.name,
        };
        return draft;
    },
    "InteractiveTool/SetDiagram": (draft: Draft<InteractiveToolState>, action: { diagram: Diagram }) => {
        draft = {
            ...draft,
            selectedDrigram: action.diagram.name,
        };
        return draft;

    },
    "InteractiveTool/SetPositions": (draft: Draft<InteractiveToolState>, action: { positions: Position[] }) => {
        draft = {
            ...draft,
            selectedPositions: action.positions,
        };
        return draft;

    },
});

(reducers as any).interactiveToolState = interactiveToolStateStateImmerReducer;

type InteractiveToolReducers = {
    interactiveToolState: typeof interactiveToolStateStateImmerReducer;
};

export type InteractiveToolActions = Parameters<InteractiveToolReducers[keyof InteractiveToolReducers]>[1] | AnyAction;

